export const TROUSER_DEFAULT_MEASUREMENTS = {
  trouserLengthMode: 'full',
  waist: 32,
  seat: 40,
  rise: 10.5,
  outseam: 42,
  thigh: 24,
  knee: 18,
  hem: 16,
  frontKnee: 8,
  frontHem: 7,

  forkWidth: 2.0,
  cfDrop: 0.5,
  creaseOffset: 0,
  backCreaseOffset: 0,
  frontThighSideOffset: 0,
  frontWaistAdd: 0.375,
  frontHipAdd: -0.375,

  cbSeatOffset_X: -1.0,
  cbSeatOffset_Y: 0.75,
  backThighSideOffset: 0.75,
  cbWaistHeight: 1.5,
  cbWaistOffsetX: 0,
  backDartWidth: 1.5,
  backDartDepth: 4.5,
  backDartMode: 'one',
  useTwoBackDarts: false,
  backDartSpacing: 2.25,
  backWaistAdd: -0.375,
  backHipAdd: 0.375,

  hipLevelInput: 7.0,
  kneeLevelInput: 24.25,

  backCrotchScoopX: -0.25,
  backCrotchScoopY: 1.0,

  frontWaistToHipSideCtrlDx: 0,
  frontWaistToHipSideCtrlDy: 0,
  backWaistToHipSideCtrlDx: 0,
  backWaistToHipSideCtrlDy: 0,
  frontSeatToThighSideCtrlDx: 0,
  frontSeatToThighSideCtrlDy: 0,
  backSeatToThighSideCtrlDx: 0,
  backSeatToThighSideCtrlDy: 0,
  frontThighToKneeSideCtrlDx: 0,
  frontThighToKneeSideCtrlDy: 0,
  frontThighToKneeSideCtrlStartDx: 0,
  frontThighToKneeSideCtrlStartDy: 0,
  frontThighToKneeSideCtrlEndDx: 0,
  frontThighToKneeSideCtrlEndDy: 0,
  backThighToKneeSideCtrlDx: 0,
  backThighToKneeSideCtrlDy: 0,
  backThighToKneeSideCtrlStartDx: 0,
  backThighToKneeSideCtrlStartDy: 0,
  backThighToKneeSideCtrlEndDx: 0,
  backThighToKneeSideCtrlEndDy: 0,
  frontInseamThighToKneeCtrlDx: 0,
  frontInseamThighToKneeCtrlDy: 0,
  backInseamThighToKneeCtrlDx: 0,
  backInseamThighToKneeCtrlDy: 0,
  frontCrotchCurveCtrlDx: 0,
  frontCrotchCurveCtrlDy: 0,
  backWaistCenterCurveCtrlDx: 0,
  backWaistCenterCurveCtrlDy: 0,
  backCrotchCurveCtrlDx: 0,
  backCrotchCurveCtrlDy: 0,

  enablePleats: false,
  pleatDirection: 'reverse',
  pleatCount: 1,
  pleatDepth: 1.75,
  secondPleatSpacing: 1.5,
  secondPleatDepth: 1.25,
};
